import { getCookie, setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'
import { IncomingMessage, ServerResponse } from 'http'

import { JUSIA_ALERT_CLICKED_LINK } from '../constants'

const getJusIAAlertViewKey = (pid = 'user') => {
  return `${pid}-${JUSIA_ALERT_CLICKED_LINK}`
}

const setJusIAAlertView = (pid = 'user', response: ServerResponse | null = null) => {
  setJusbrasilCookie(response, getJusIAAlertViewKey(pid), Date.now())
}

const getJusIAAlertView = (pid = 'user', request: IncomingMessage | null = null) => {
  return getCookie(request, getJusIAAlertViewKey(pid))
}

export const jusIAPersistentAlertBannerPersisted = {
  getKey: getJusIAAlertViewKey,
  set: setJusIAAlertView,
  get: getJusIAAlertView,
}
